/**
  * 角色模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const roleApi = {
    GetDataList: `${base.qa}/Role/GetDataList`,
    SaveData: `${base.qa}/Role/SaveData`,
    GetDataById: `${base.qa}/Role/GetDataById`,
    DelData: `${base.qa}/Role/DelData`,

    GetRoleDataTree: `${base.qa}/RoleUserModule/GetRoleDataTree`,
    SaveRoleData: `${base.qa}/RoleUserModule/SaveRoleData`,


    GetRoleModuleAndBtns: `${base.qa}/RoleUserModule/GetRoleModuleAndBtns`,
    SaveRoleButtons: `${base.qa}/RoleUserModule/SaveRoleButtons`,
}

const role = {
    GetDataList (pageindex, pagesize) {
        return axios.get(roleApi.GetDataList, { params: { pageindex, pagesize } })
    },
    SaveData (params) {
        return axios.post(roleApi.SaveData, params)
    },
    GetDataById (params) {
        return axios.get(roleApi.GetDataById, { params: { roleid: params } })
    },
    DelData (params) {
        return axios.post(roleApi.DelData, params)
    },

    GetRoleDataTree (roleid) {
        return axios.get(roleApi.GetRoleDataTree, { params: { roleid } })
    },
    SaveRoleData (params) {
        return axios.post(roleApi.SaveRoleData, params)
    },

    GetRoleModuleAndBtns (roleid) {
        return axios.get(roleApi.GetRoleModuleAndBtns, { params: { roleid } })
    },
    SaveRoleButtons (params) {
        console.log(params);
        return axios.post(roleApi.SaveRoleButtons, params)
    },
}


export default role;